import {
  hardwireTakeoverModule,
  zoneExpander,
  powerSupply
} from '../../../../utils/constant';

/**
 * Returns takeover equipment field config (value + minValue per field) for the given wired sensors quantity.
 * Tiers: 1-8 (1 module); 9-16 (+1 zone expander +1 power supply); 17-24 (+2 each); 0 or other: clear all.
 * Caller should apply the returned config to the takeover section (no mutation in this function).
 * @param {number} qty - Wired sensors quantity
 * @returns {{ [key: string]: { value: number, minValue: number } }} Config keyed by field name
 */
export const getTakeoverEquipmentConfigForWiredSensors = (qty) => {
  const tiers = [
    { minQty: 1, maxQty: 8, [hardwireTakeoverModule]: { value: 1, minValue: 1 }, [zoneExpander]: { value: 0, minValue: 0 }, [powerSupply]: { value: 0, minValue: 0 } },
    { minQty: 9, maxQty: 16, [hardwireTakeoverModule]: { value: 1, minValue: 1 }, [zoneExpander]: { value: 1, minValue: 1 }, [powerSupply]: { value: 1, minValue: 1 } },
    { minQty: 17, maxQty: 24, [hardwireTakeoverModule]: { value: 1, minValue: 1 }, [zoneExpander]: { value: 2, minValue: 2 }, [powerSupply]: { value: 2, minValue: 2 } }
  ];
  const defaultTier = { [hardwireTakeoverModule]: { value: 0, minValue: 0 }, [zoneExpander]: { value: 0, minValue: 0 }, [powerSupply]: { value: 0, minValue: 0 } };
  const matched = tiers.find(t => qty >= t.minQty && qty <= t.maxQty);
  return matched || defaultTier;
};
